

import './TaskSource.scss';


const TaskSource = (props) => {
  
 
  const Container = (props) => {

   return (
      <div className='TaskSource'  >
          {props.index+1}. {props.task.content}
      </div>
    )
  }



    return (
   
            <Container 
            task={props.task} 
            index={props.index}
            />
 
    );




  }
  
  export default TaskSource;